import React, { useEffect, useState } from 'react';
import "./Navbar.css";
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo/logo.png';
import signLogo from '../../assets/logo/signup.png';
import { RiShoppingCart2Line, RiMenuFill, RiCloseLine } from "react-icons/ri";
import { useProducts } from '../../Context/ProductProvider';
import Loading from '../../pages/Loading/Loading';
import User from './User';
import CategoriesItem from './CategoriesItem';




const Navbar = ({ children }) => {
    // const navigate = useNavigate();
    // const [category, setCategory] = useState([])



    


    
    // const [displayCount, setDisplayCount] = useState(20);
    // useEffect(() => {
        
    //     async function fetchData() {
    //         try {
    //             const response = await fetch('https://wehatbazar.thecell.tech/api/category', {
    //                 method: "GET",
    //                 headers: {
    //                     "X-Requested-With": "XMLHttpRequest",
    //                     "content-type": "application/json",
    //                     "authorization": `Bearer ${localStorage.getItem('token')}`
    //                 },
    //             });
    //             const data = await response.json(); 
    //             setCategory(data?.data); 
    //         } catch (error) {
    //             console.error(error);
    //         }
    //     }
    //     fetchData(); 
    // }, []);

    // const handleShowMore = () => {
    //     setDisplayCount(category.length);
    // };

    // console.log(category)


    // const redirectToCategoriesProducts = (categoryId) => {
    //     navigate(`/categories-products/${categoryId}`);
    // };

    // console.log(redirectToCategoriesProducts(18))

    const { state: { cart }, loading, error } = useProducts();
    
    let content;

    if (loading) {
        return <Loading></Loading>
    }
    if (error) {
        content = <h1>Something went wrong</h1>
    }
    return (
        <div className='sticky top-0 z-20 w-full'>
            <header className="py-4 shadow-sm bg-white">
                <div className="container flex items-center justify-between">
                    <Link to="/">
                        <img src={logo} style={{ width: "150px" }} className="lg:w-full" alt="Logo" />
                    </Link>

                    <div className="flex items-center space-x-6">
                        <Link to='/cart' className="text-center text-gray-700 hover:text-primary transition relative">
                            <div className="text-lg lg:text-2xl">
                                <RiShoppingCart2Line />
                            </div>

                            <div className="absolute left-4 -top-1 w-5 h-5 rounded-full flex items-center justify-center bg-primary text-white text-xs">{cart?.length} {content}</div>
                        </Link>
                        <Link to="/sign-up" className="text-center text-gray-700 hover:text-primary transition relative">
                            <div className="text-2xl">
                                <img src={signLogo} alt="" className='w-[60px] lg:w-full' />
                            </div>
                        </Link>
                    </div>
                </div>
            </header>
            <nav>
                <div class="wrapper container">
                    <input type="radio" name="slide" id="menu_btn" /><input type="radio" name="slide" id="cancel_btn" />
                    <ul class="nav_links">
                        <label for="cancel_btn" class="btnn hover:bg-inherit text-white bg-[#7811D4] border-0 cancel_btn mt-2 text-2xl">
                            <RiCloseLine className='mt-2 text-2xl font-bold'></RiCloseLine>
                        </label>
                        <li><Link className='lg:pl-[0px]' to="/">Home</Link></li>
                        <li><Link to="/shop">Shop</Link></li>
                        
                        {/* <li>
                            <Link to="/" class="desktop_item">Dropdown Menu</Link>
                            <input type="checkbox" id="showDrop" />
                            <label for="showDrop" class="mobile_item">Dropdown Menu</label>
                            <ul class="drop_menu">
                                {category.map(item => (
                                    <li key={item.id}><Link >{item.name}</Link></li>
                                ))}
                            </ul>
                        </li> */}
                        <li>
                            <Link to="/" class="desktop_item">Categories</Link>
                            <input type="checkbox" id="showMega" />
                            <label for="showMega" class="mobile_item">Categories</label>
                            <div class="mega_box">
                                <CategoriesItem></CategoriesItem>

                            </div>
                        </li>
                        <li className='p-5 lg:hidden'>
                            <User></User>
                        </li>
                    </ul>

                    <label for="menu_btn" class="btnn hover:bg-inherit  mt-3 text-white bg-[#7811D4] border-0 menu_btn">
                        <RiMenuFill className='mt-2 text-2xl'></RiMenuFill>
                    </label>
                    <div className='lg:block hidden'>
                        <User></User>
                    </div>
                </div>
            </nav>
            {children}
        </div>
    );
};

export default Navbar;